import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers";
import {
  createBadgeBlock,
  createButtonBlock,
  createH2Block,
  createH5Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getMarginOptions } from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import checkBulletImage from "../../Content/UlListBlock/check_bullet.png";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

const cards = [
  {
    highlight: "",
    header: "Essentials",
    price: "$3,987",
    badge: "One Time Investment",
    description:
      "Perfect for self-motivated professionals who need guidance and structure.",
    featuresTitle: "Includes:",
    features: [
      "12 Weekly Group Coaching Calls",
      "Complete Video Module Library",
      "Private Community Access",
      "Basic Email Support",
      "Accountability System",
    ],
    buttonText: "Apply Now",
    buttonHref: "#",
    buttonVariant: "secondary",
    footer: "",
  },
  {
    highlight: "Most popular",
    header: "Breakthrough",
    price: "$3,987",
    badge: "One Time Investment",
    description:
      "Our most popular option for professionals seeking personalized transformation.",
    featuresTitle: "Includes:",
    features: [
      "12 Weekly 1:1 Coaching Sessions",
      "Strategic Planning Workshop",
      "Complete Video Module Library",
      "Private Community Access",
      "VIP Support Between Sessions",
      "Personalized Resources & Tools",
      "Lifetime Access to Materials",
    ],
    buttonText: "Apply Now (Limited Spots)",
    buttonHref: "#",
    buttonVariant: "primary",
    footer: "Only 3 spots remaining this month",
  },
];

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock9_2",
  meta: {},
  props: {
    header: {
      meta: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
      },
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Invest in Your Transformation",
        }),
        createPBlock({
          text: "Choose the option that best fits your goals and commitment level.",
        }),
      ],
    },
    content: {
      meta: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
      },
      prop: "children",
      type: "children",
      value: cards.map(
        ({
          highlight,
          header,
          price,
          badge,
          description,
          featuresTitle,
          features,
          buttonText,
          buttonHref,
          buttonVariant,
          footer,
        }) =>
          createCardBlock({
            highlight,
            value: [
              createH5Block({ text: header }),
              createH2Block({
                text: price,
              }),
              createBadgeBlock({ text: badge }),
              createPBlock({
                text: description,
                paragraphStyle: "p3",
              }),
              createPBlock({
                text: featuresTitle,
                paragraphStyle: "p3",
              }),
              createUlBlock({
                items: features.map(feature => ({
                  text: feature,
                  placeholder: checkBulletImage,
                })),
              }),
              createButtonBlock({
                text: buttonText,
                href: buttonHref,
                buttonType:
                  buttonVariant === "primary"
                    ? "primaryButton"
                    : "secondaryButton",
                styles: {
                  margin: getMarginOptions({
                    defaultValue: {
                      marginTop: "30",
                      marginBottom: "0",
                      marginLeft: "0",
                      marginRight: "0",
                    },
                  }),
                },
              }),
              createPBlock({
                text: footer,
                paragraphStyle: "p3",
                styles: {
                  textAlign: getTextAlignOptions("center"),
                },
              }),
            ],
          }),
      ),
    },
    footer: {
      meta: {
        name: "Footer",
        nameI18n: "builder_ui.prop_type.footer",
      },
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Payment plans available. Schedule a free consultation to discuss options.",
          paragraphStyle: "p3",
        }),
        createButtonBlock({
          text: "Book Your Free Strategy Call",
          href: "#",
          buttonType: "primaryButton",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
